import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import { objectAsParams } from '../../../helpers';

class NotaCredito extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'nota-credito-factura/one', saveUrl: 'nota-credito-factra/save', backUrl: 'jfhdfs' },
      new Form([
        Form.Field('number', 'importeNota', 'Valor de nota', this.props.notaCredito.importe, [Validators.required], 4, [], [], [], false, true),
        Form.Field('text', 'letra', 'Letra', 'CYC', [], 3, [], [], [], false, true),
        Form.Field('autocomplete', 'id_factura', 'Folio de factura', '', [Validators.required], 5),
        Form.Field('number', 'subtotal', 'Subtotal', '', [Validators.required], 3),
        Form.Field('number', 'iva', 'I.V.A.', '', [Validators.required], 2),
        Form.Field('number', 'retencion', 'Retención', '', [Validators.required], 2),
        Form.Field('number', 'restante', 'Valor aplicado', '', [Validators.required], 2),
        Form.Field('number', 'total', 'Total de factura', '', [Validators.required], 3, [], [], [], false, true),
      ], ['Guardar'], ''), this.formData
    )
    if (this.props.notaFactura) {
      this.facturaId = this.props.notaFactura.id_factura;
      this.LoadPreds(this.props.notaFactura.id, false);
    }

    console.log(this.props.notaCredito)
  }

  // loadPreds = async () => {
  //   console.log(this.props.notaFactura)

  //   this.setState({ FormData: Form.Patch(this.state.FormData, { ...this.props.notaFactura, restante:  }, true) })
  // }

  formData = async (form) => {
    let params = {}, newForm = form;
    params["credito_contado"] = this.props.notaCredito.credito_contado;
    if (this.facturaFolio) {
      params["factura_folio"] = this.facturaFolio;
      this.facturaFolio = null;
    }

    const Res = await Http.get(`nota-credito/factura/form?${objectAsParams(params)}`)
    if (!Res.error) {
      const { facturas } = Res.data;
      if (facturas) {
        newForm = Form.FieldOptions(newForm, 'id_factura', facturas, 'id', 'tipo_cons');
      }
    }
    console.log(Res)

    newForm = Form.ValueChange(form, {
      id_factura: this.facturaChange,
      subtotal: this.calcularTotal,
      iva: this.calcularTotal,
      retencion: this.calcularTotal,
    });
    return newForm;
  }

  calcularTotal = () => {
    const values = Form.GetValues(this.state.FormData, ['subtotal', 'iva', 'retencion']);
    for (const key in values) {
      let parsedVal = parseFloat(values[key]);
      if (!values[key] || isNaN(parsedVal)) return;
      values[key] = parsedVal;
    }
    const { subtotal, iva, retencion } = values;
    console.log(values);
    let total = subtotal + iva - retencion;
    total = total.toFixed(2);
    this.setState({ FormData: Form.Patch(this.state.FormData, { restante: total }, false) });
  }

  facturaChange = async (field) => {
    if (field.Value) {
      this.facturaId = field.Value;
      let Res = await Http.get(`facturas/one/${field.Value}`);
      if (!Res.error) {
        console.log(Res.data);
        // const { linea, fecha_vencimiento, total, g_costo_iva, g_costo_retencion, restante } = Res.data;
        this.setState({
          FormData: Form.Patch(this.state.FormData, {
            subtotal: Res.data.restante_subtotal,
            iva: Res.data.restante_iva,
            retencion: Res.data.restante_retencion,
            total: Res.data.total,
            restante: Res.data.restante
          }, true),
        });
      }
    }
    else {
      // console.log('valueat')
      this.facturaFolio = field.ValueAt;
      this.setState({
        FormData: await this.formData(this.state.FormData)
      });
    }
  }

  onSubmit = async (button, vals) => {
    console.log(vals);
    // console.log(parseFloat(vals.subtotal), parseFloat(vals.iva), parseFloat(vals.retencion), parseFloat(vals.restante))
    // if (parseFloat(vals.subtotal) + parseFloat(vals.iva) - parseFloat(vals.retencion) !== parseFloat(vals.restante))
    //   return Snackbar("El valor aplicado debe ser igual al subtotal más el IVA menos la retención");

    // return;
    this.setState({ loading: true });
    try {
      let resData = {
        ...vals,
        id_factura: this.facturaId,
        id_nota_credito: this.props.match.params.id,
        total: vals.restante,
        id: this.props.notaFactura?.id || null,
      }
      // return
      let Res = await Http.post(`nota-credito/factura/save`, resData);
      console.log(Res)
      if (!Res.error) {
        this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true });
        this.props.onSave();
      }
      else {
        this.setState({ loading: false, sbMsg: `Error al guardar${(Res.errMsg ? `: ${Res.errMsg}` : '')}`, sbOpen: true });
      }
    } catch (error) {
      console.log(error)
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div style={{ backgroundColor: 'white' }}>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(NotaCredito)
